// Handle anchor link clicks to prevent scroll conflicts with sticky header
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href^="#"]');
  if (!link) return;
  
  const href = link.getAttribute('href');
  if (!href || href === '#') return;
  
  // Skip if handled by other specific handlers
  if (link.closest('.in-page-navigation')) return;
  
  const targetId = href.substring(1);
  const targetElement = document.getElementById(targetId);
  if (!targetElement) return;
  
  // Skip if it's a modal (handled by modal.js)
  if (targetElement.classList.contains('modal')) return;
  
  // Prevent default browser scroll
  e.preventDefault();
  
  // Calculate scroll direction and set header state before scrolling
  const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
  const currentPosition = window.pageYOffset;
  const willScrollUp = targetPosition < currentPosition;
  
  const stickyAddToCartBannerHeight = document.querySelector('.sticky-add-to-cart-banner ')?.offsetHeight || 0;
  const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
  const totalHeight = stickyAddToCartBannerHeight + headerHeight;
  
  // Update CSS variable BEFORE scrolling based on future header state
  if (willScrollUp) {
    // Scrolling up - header will be visible
    document.documentElement.style.setProperty('--scroll-margin-top', `${totalHeight}px`);
  } else {
    // Scrolling down - header will be hidden
    document.documentElement.style.setProperty('--scroll-margin-top', `${stickyAddToCartBannerHeight}px`);
  }
  
  // Update URL hash
  window.history.pushState(null, '', href);
  
  // Scroll to target
  targetElement.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}, true); // Use capture phase to run before other handlers
